import { Button, Select, Table, Typography, Pagination, Input } from 'antd'
import { Badge } from 'flowbite-react'
import React, { useEffect, useState } from 'react'
import { Link, useLoaderData, useNavigate } from 'react-router-dom'

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Color',
    dataIndex: 'color',
    key: 'color',
    className: `whitespace-nowrap font-medium dark:text-white`,
    render: (_, record) => <div className={`rounded-full text-center`} style={{backgroundColor: record.color, color: record.color, width: '22px'}}>.</div>
  },
  {
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    className: 'whitespace-nowrap font-medium dark:text-white',
    render: (_, record) => <Badge className={record.active ? "text-green-950 bg-green-100 w-max" : "text-red-950 bg-red-100 w-max"}>{record.active ? 'active' : 'inactive'}</Badge>
  },
  // {
  //   title: 'Action',
  //   key: 'operation',
  //   fixed: 'right',
  //   width: 100,
  //   className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  //   render: (_, record) => (
  //     <Link className='h-full w-full' to={'/accounting/analytic-accounts/'+record.seo}>
  //       EDIT
  //     </Link>
  //   )
  // }
]

const options = []
for (let i = 10; i < 36; i++) {
  options.push({
    value: i.toString(36) + i,
    label: i.toString(36) + i
  })
}
const handleChange = (value) => {
  console.log(`Selected: ${value}`)
}

const Tags = () => {
  const tags = useLoaderData();
  const [current, setCurrent] = useState(3);
  const navigate = useNavigate();
  const onChange = (page) => {
    console.log(page)
    setCurrent(page)
  }

  
  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/accounting/tags/'+record.seo)
    };
  }
  
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Tags</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            onChange={handleChange}
            className='w-96'
            options={options}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/tags/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination current={current} onChange={onChange} total={50} />
          </div>
        </div>
      </div>
      <Table
        rowClassName={'hover:cursor-pointer'}
        dataSource={tags}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'name'}
        onRow={onRow}
      />
    </div>
  )
}

export default Tags;
